/**
 * Entrega ao navegador um arquivo que chegou como blob.
 *
 * O CSV das listas e a cópia de grupo dos materiais fazem a mesma coisa, e o
 * detalhe que erra calado é o momento de liberar a URL: liberada antes de o
 * navegador começar o download, o arquivo sai vazio. Um lugar só.
 */
export function baixarBlob(blob: Blob, nome: string): void {
  const endereco = URL.createObjectURL(blob);
  const ancora = document.createElement('a');
  ancora.href = endereco;
  ancora.download = nome;
  document.body.appendChild(ancora);
  try {
    ancora.click();
  } finally {
    ancora.remove();
    // O navegador precisa iniciar o download antes de liberar o conteúdo.
    setTimeout(() => URL.revokeObjectURL(endereco), 0);
  }
}
